import { CgProfile, CgLock, CgLogOut } from 'react-icons/cg';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/auth.hook';
import { useRootSelector } from '@/hooks/selector.hook';
import { useEffect } from 'react';

export default function DropdownMenuDemo() {
  const { clearData, fetchProfile } = useAuth();
  const { user, token } = useRootSelector((state) => state.auth);

  useEffect(() => {
    if (token) {
      fetchProfile();
    }
  }, []);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="profile flex items-center gap-2 cursor-pointer">
          <Avatar>
            <AvatarImage src={user?.avatar} alt={user?.email} />
            <AvatarFallback>CN</AvatarFallback>
          </Avatar>

          <div className="userName text-[1.5rem] hidden lg:block">
            {user?.firstName} {user?.lastName}
          </div>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="min-w-[20rem] mt-[0.5rem] p-[0.8rem] rounded-[0.5rem] dark:bg-[#272727] border-none shadow-lg"
        align="end"
      >
        <DropdownMenuLabel className="font-normal italic text-[1.5rem] mb-[0.5rem] text-foreground">
          {user?.roles?.[0]?.name}
        </DropdownMenuLabel>
        <DropdownMenuSeparator className="my-[0.5rem] bg-gray-300 dark:bg-gray-700" />
        <DropdownMenuGroup>
          <DropdownMenuItem className="h-[3rem]   !p-0 hover:bg-accent hover:text-accent-foreground rounded-md transition-colors">
            <Link
              to={'/profile'}
              className="dropdownItem flex items-center gap-2 w-full p-2 text-foreground hover:text-accent-foreground"
            >
              <CgProfile size={24} className="!w-6 !h-6 text-muted-foreground" />
              <span className="text-[1.5rem]">Profile</span>
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem className="h-[3rem]   !p-0 hover:bg-accent hover:text-accent-foreground rounded-md transition-colors">
            <Link
              to={'/Security'}
              className="dropdownItem flex items-center gap-2 w-full p-2 text-foreground hover:text-accent-foreground"
            >
              <CgLock size={24} className="!w-6 !h-6 text-muted-foreground" />
              <span className="text-[1.5rem]">Security</span>
            </Link>
          </DropdownMenuItem>
        </DropdownMenuGroup>
        <DropdownMenuSeparator className="my-[0.5rem] bg-gray-300 dark:bg-gray-700" />
        <DropdownMenuItem className="h-[3rem] cursor-pointer !p-0 hover:bg-destructive/10 hover:text-[red] rounded-md transition-colors">
          <Button variant="logout" size="logout" onClick={() => clearData()}>
            <CgLogOut size={24} className="!w-6 !h-6 text-[red]" />
            <span className="text-[1.5rem] text-[red]">Logout</span>
          </Button>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
